import React from "react";
import Navbar from "./Navbar";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import indsacmobilecrm from "../Images/indsac-mobile-crm.gif";

export default function ProjectAccounting() {
  return (
    <>
      {/* <!-- Required meta tags --> */}
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta
        name="description"
        content="Mobile CRM can be defined as a CRM platform that has been specifically designed for mobile devices and tablets"
      />
      <meta property="og:title" content="Mobile CRM" />
      <meta property="og:type" content="article" />
      <meta
        property="og:url"
        content="https://entelipro.com/digitalmobile.jsp"
      />
      <meta
        property="og:image"
        content="https://www.entelipro.com/static/media/indsac-mobile-crm.gif"
      />
      <meta
        property="og:image:secure_url"
        content="https://www.entelipro.com/static/media/indsac-mobile-crm.gif"
      />
      <meta property="og:site_name" content="entelipro.com" />
      <meta
        property="og:description"
        content="Mobile CRM can be defined as a CRM platform that has been specifically designed for mobile devices and tablets"
      />
      <meta property="og:locale" content="en_US" />
      <title>Project Accounting | Digital & Mobile :: entelipro.com</title>

      <script type="application/ld+json">
        `
        {`"@context":"https://schema.org","@type":"WebPage","name":"Mobile CRM",
                "logo":{"@type":"ImageObject","url":"https://www.entelipro.com/web/dist/img/u.png"},"url":"https://www.entelipro.com/digitalmobile"`}
        `
      </script>

      <Navbar />
      {/* <!-- breadcrumbs --> */}
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li>
                <Link to="/services">
                  Services{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li>
                <Link to="/projectmanagement">
                  Project Management{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>

              <li className="active">Project Accounting</li>
            </ul>
          </div>
        </div>
      </section>
      {/* <!-- breadcrumbs //--> */}
      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={indsacmobilecrm}
                  alt="product"
                  className="img-responsive "
                />
              </div>
              <div className="cwp4-text col-xl-6">
                <h4>Project Accounting</h4>
                <p className="para">
                  Project Accounting focuses on managing the financial aspects
                  of a project. It includes budgeting, cost tracking, and
                  revenue recognition. This function helps in monitoring project
                  expenses, comparing actual costs with budgeted amounts, and
                  ensuring that projects remain profitable. By integrating with
                  the Finance and Accounting module, Project Accounting provides
                  a comprehensive view of a project's financial health, helping
                  organizations make informed decisions about resource
                  allocation and project prioritization.
                </p>
                <div className="jst-two-coloums mt-4">
                  <div className="icon-text">
                    <h5>
                      {" "}
                      <a href="#"></a>
                    </h5>
                    <p className="para">
                      Flexibility is an essential requirement for most
                      professionals today due to the diverse working conditions,
                      including remote working, work from home, and more. 
                    </p>
                  </div>
                  <div className="icon-text mt-lx-3 pt-lx-1">
                    <h5>
                      <a href="#"></a>
                    </h5>
                    <p className="para">
                      With the help of mobile CRM, employees can have access to
                      important data irrespective of their location.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="w3l-recent-work-hobbies">
        <div className="recent-work ">
          <div className="container">
            <div className="left-text">
              <h3>Here are some benefits of Project Accounting</h3>
              <div className="row about-about">
                <div className="col-lg-4 col-md-6">
                  <div className="about-grids">
                    <h4>Accurate Budgeting and Forecasting</h4>
                    <p className="para">
                      Enables precise budgeting and forecasting for projects,
                      ensuring that financial resources are allocated
                      appropriately and potential financial risks are identified
                      early.
                    </p>
                    <br />
                    <div className="mt-3 about-list"></div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 about-line-top">
                  <div className="about-grids">
                    <h4>Real-Time Financial Visibility</h4>

                    <p className="para">
                      Provides real-time insights into project costs and
                      revenues, allowing for better financial control and timely
                      adjustments to keep projects on track.
                      <br />
                      <br />
                    </p>
                    <br />
                    <div className="mt-3 about-list"></div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 about-line-top">
                  <div className="about-grids">
                    <h4>Enhanced Profitability Tracking</h4>
                    <p className="para">
                      {" "}
                      Monitors project profitability by comparing actual costs
                      with budgeted amounts, helping organizations ensure that
                      projects contribute positively to the bottom line.
                    </p>
                    <br />
                    <div className="mt-3 about-list"></div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 about-line-top">
                  <div className="about-grids">
                    <h4>Improved Decision-Making</h4>
                    <p className="para">
                      Offers a clear view of a project's financial health,
                      enabling informed decisions about resource allocation,
                      project prioritization, and potential course corrections.
                    </p>
                    <br />
                    <div className="mt-3 about-list"></div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 about-line-top">
                  <div className="about-grids">
                    <h4>Streamlined Revenue Recognition</h4>
                    <p className="para">
                      {" "}
                      Ensures accurate and timely recognition of project
                      revenues, supporting compliance with financial reporting
                      standards and enhancing financial transparency.
                    </p>
                    <br />
                    <div className="mt-3 about-list"></div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="about-grids">
                    <h4>Cost Control and Management</h4>
                    <p className="para">
                      {" "}
                      Helps in tracking and controlling project expenses,
                      preventing cost overruns and ensuring that projects stay
                      within budget.
                    </p>
                    <br />
                    <div className="mt-3 about-list"></div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 about-line-top">
                  <div className="about-grids">
                    <h4>Integration with Core Financials</h4>

                    <p className="para">
                      Seamlessly integrates with the Finance and Accounting
                      module, providing a unified view of project and
                      organizational finances, and supporting comprehensive
                      financial analysis.
                      <br />
                      <br />
                    </p>
                    <br />
                    <div className="mt-3 about-list"></div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 about-line-top">
                  <div className="about-grids">
                    <h4>Improved Cash Flow Management:</h4>
                    <p className="para">
                      Facilitates better cash flow management by tracking
                      project-related income and expenditures, ensuring that
                      projects are financially sustainable.
                    </p>
                    <br />
                    <div className="mt-3 about-list"></div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 about-line-top">
                  <div className="about-grids">
                    <h4>Compliance and Audit Readiness</h4>
                    <p className="para">
                      {" "}
                      Ensures that financial data related to projects is
                      accurate, well-documented, and audit-ready, supporting
                      regulatory compliance and reducing the risk of financial
                      discrepancies.
                    </p>
                    <br />
                    <div className="mt-3 about-list"></div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 about-line-top">
                  <div className="about-grids">
                    <h4>Resource Optimization</h4>
                    <p className="para">
                      By closely monitoring project costs and financial
                      performance, Project Accounting helps in optimizing the
                      use of resources, ensuring that they are used efficiently
                      and effectively.
                    </p>
                    <br />
                    <div className="mt-3 about-list"></div>
                  </div>
                </div>
              </div>
              <br />
              <br />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
